export default __webpack_public_path__ + "static/media/DPE_A.c007bb10.png";